module.exports = __webpack_public_path__ + "static/media/unloaded_inactive.dbf5f522.svg";